import type { Action, PolicyType, SubType } from "@/api/usePolicies.types"
import type { Permission, Resource } from "@/domain/user"

export const PROTECT_SUB_TYPE_POLICY = "protect"
export const SUPPRESS_SUB_TYPE_POLICY = "suppress"
export const FAIL_ACTION: Action = "FAIL"

export const isSuppressSubTypePolicy = (type?: string) =>
  type === SUPPRESS_SUB_TYPE_POLICY

// Map ci-sca and ci-sast to ci for permissions and events
export const getBaseType = (type: PolicyType): "ci" | "scm" | "code" => {
  if (type === "ci-sca" || type === "ci-sast") return "ci"
  return type
}

export const getResourcePermission = (type: PolicyType): Resource =>
  `${getBaseType(type)}.policies`

export const getPermission = (type: PolicyType): Permission => ({
  resource: getResourcePermission(type),
  action: "write"
})

// CI policies have no policy exceptions.
export const isPolicyExceptionsType = (type: PolicyType) =>
  type === "scm" || type === "code"

export const canAllowPolicyExceptions = (params: {
  type: PolicyType
  subType: SubType
  action?: Action
}) =>
  isPolicyExceptionsType(params.type) &&
  !isSuppressSubTypePolicy(params.subType) &&
  params.action === FAIL_ACTION
